import isBrowserContext from "helpers/isBrowserContext";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

export default (name?: string) => {
    const location = useLocation();
    const [identifier, setIdentifier] = useState<string | undefined>();

    useEffect(() => {
        // Identifing
        if (typeof(identifier) === "undefined") {
            if (typeof(name) !== "undefined" && name.length > 0) {
                const slug = name.replace(/\s+/g, "-");
                setIdentifier(slug);
            }
        }

        // Scrolling
        if (isBrowserContext() && typeof(identifier) !== "undefined" && identifier === location.hash?.replace("#", "")) {
            setTimeout(() => {
                const element = window.document.getElementById(identifier);
                window.scrollTo(0, element?.offsetTop ?? 0);
            }, 250);
        }
    }, [identifier, name]);

    return identifier;
};